import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isOut:false,
    loading:false,
    url: "http://shop.backend.xcxstore.com"
  },
  mutations: {
    setLoading(state, value){
      state.loading = value;
    },
    setIsOut(state, value){
      state.isOut = value;
    }
  },
  actions: {
  },
  modules: {
  }
})
